import React from 'react';
export function Banner() {
  return <div className="w-full bg-teal text-white py-12 px-6 text-center" data-id="element-37">
      <h2 className="text-2xl md:text-3xl font-serif font-light tracking-wide" data-id="element-38">
        Personalized coaching. Practical strategies.{' '}
        <span className="underline decoration-accent decoration-2 underline-offset-8" data-id="element-39">
          Real momentum.
        </span>
      </h2>
    </div>;
}